import { render, staticRenderFns } from "./CgsbcxmxView.vue?vue&type=template&id=52ade35c&scoped=true"
import script from "./CgsbcxmxView.vue?vue&type=script&lang=js"
export * from "./CgsbcxmxView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ade35c",
  null
  
)

export default component.exports